export default function useEnums() {

  const auctionStatuses = [
    ['DRAFT', 'Bozza', 'Bozze'],
    ['PUBLISHED', 'Pubblicata', 'Pubblicate'],
    ['OPEN', 'Aperta', 'Aperte'],
    ['CLOSED', 'Chiusa', 'Chiuse'],
    ['REDISTRIBUTING_1', 'Redistribuzione (fase 1)', 'Redistribuzione  (fase 1)'],
    ['REDISTRIBUTING_2', 'Redistribuzione (fase 2)', 'Redistribuzione  (fase 2)']
  ];

  const auctionTypes = [
    ['STANDARD', 'Standard', 'Standard'],
    ['REDISTRIBUTE', 'Redistributiva', 'Redistributive']
  ];

  const getLabel = (e, key) => {
    const found = e.find((item) => item[0] == key)
    if(found) return found[1];
    return '-';
  };
  const getPluralLabel = (e, key) => {
    const found = e.find((item) => item[0] == key);
    if(found) return found[2];
    return '-';
  }
  const getAllLabels = (e) => {
    return e.reduce((carry, item) => {
      carry[item[0]] = item[1];
      return carry
    }, {})
  }
  const getAllPluralLabels = (e) => {
    return e.reduce((carry, item) => {
      carry[item[0]] = item[1];
      return carry
    }, {})
  }

  const getAuctionStatusLabel = (key) => getLabel(auctionStatuses, key);
  const getAuctionStatusPluralLabel = (key) => getPluralLabel(auctionStatuses, key);
  const getAuctionStatusAllLabels = () => getAllLabels(auctionStatuses);
  const getAuctionStatusAllPluralLabels = () => getAllPluralLabels(auctionStatuses);

  const getAuctionTypeLabel = (key) => getLabel(auctionTypes, key);
  const getAuctionTypePluralLabel = (key) => getPluralLabel(auctionTypes, key);
  const getAuctionTypeAllLabels = () => getAllLabels(auctionTypes);
  const getAuctionTypeAllPluralLabels = () => getAllPluralLabels(auctionTypes);

  return {
    getAuctionStatusLabel, getAuctionStatusPluralLabel, getAuctionStatusAllLabels, getAuctionStatusAllPluralLabels,
    getAuctionTypeLabel, getAuctionTypePluralLabel, getAuctionTypeAllLabels, getAuctionTypeAllPluralLabels
  }
}
